module.exports = __webpack_public_path__ + "static/media/mage-attack-button.988978ee.png";